import React from 'react';
import { WhatsAppButton } from './WhatsAppButton';
export function Header() {
  return <header className="sticky top-0 z-50 w-full bg-white border-b border-gray-100 shadow-sm" data-id="element-53">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-54">
        <div className="flex justify-between items-center h-20" data-id="element-55">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center gap-2" data-id="element-56">
            <div className="w-10 h-10 bg-blue-800 rounded-lg flex items-center justify-center" data-id="element-57">
              <span className="text-white font-bold text-xl" data-id="element-58">iT</span>
            </div>
            <span className="font-bold text-2xl text-blue-900 tracking-tight" data-id="element-59">
              iTranscorp
            </span>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-60">
            <a href="#servicios" className="text-gray-600 hover:text-blue-800 font-medium transition-colors" data-id="element-61">
              Services
            </a>
            <a href="#proceso" className="text-gray-600 hover:text-blue-800 font-medium transition-colors" data-id="element-62">
              Process
            </a>
            <a href="#cotizar" className="text-gray-600 hover:text-blue-800 font-medium transition-colors" data-id="element-63">
              Get a Quote
            </a>
          </nav>

          {/* CTA */}
          <div className="flex items-center" data-id="element-64">
            <WhatsAppButton text="Get a Quote" size="sm" className="hidden sm:flex" data-id="element-65" />
            <WhatsAppButton text="Get a Quote" size="sm" className="sm:hidden px-3" data-id="element-66" />
          </div>
        </div>
      </div>
    </header>;
}